import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaGlobe,
  FaPhone,
  FaMapMarkerAlt,
  FaPaperPlane,
  FaRegEnvelope
} from "react-icons/fa";
import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#672220] text-white py-4 px-4 md:px-10 pt-8 ">
      <div
        className=" mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 "
        style={{ maxWidth: "1440px", margin: "auto" }}
      >
        {/* Left Section */}
        <div>
          <h3 className="text-xl font-bold text-[#D1A752]">
            Sign Up for exclusive Offers
          </h3>
          <div className="relative mt-3">
            <input
              type="email"
              placeholder="xyz@gmail.com"
              className="w-full md:w-[416px] h-[48px] px-4  bg-white text-black rounded-full outline-none"
            />
            <button className="absolute right-12 top-1/2 transform -translate-y-1/2 bg-[#672220] text-white p-2 rounded-full">
              <FaPaperPlane />
            </button>
          </div>
          <h3 className="text-xl font-bold text-[#D1A752] mt-6">
            Keep In Touch
          </h3>
          <div className="flex space-x-4 mt-2">
            <FaFacebookF className="text-xl cursor-pointer" />
            <FaTwitter className="text-xl cursor-pointer" />
            <a href="https://www.instagram.com/girglades?igsh=MXFic29sNWtnd2p0dQ==" target="_blank" rel="noopener noreferrer">
              <FaInstagram className="text-xl cursor-pointer" />
            </a>
          </div>
        </div>

        {/* Middle Section */}
        <div className="flex flex-col md:items-center">
          <h3 className="text-xl font-bold text-[#D1A752] ">Menu</h3>
          <ul className="mt-3 space-y-2">
            <li className="cursor-pointer text-[#f5f5f5] md:text-center text-lg  poppins-regular">
              <NavLink to="/">Home</NavLink>
            </li>
            <li className="cursor-pointer text-[#f5f5f5] md:text-center text-lg  poppins-regular">
              <NavLink to="/about-us"> About Us </NavLink>
            </li>
            <li className="cursor-pointer text-[#f5f5f5] md:text-center text-lg  poppins-regular">
              <NavLink to="/booking"> Booking </NavLink>
            </li>
            <li className="cursor-pointer text-[#f5f5f5] md:text-center text-lg  poppins-regular">
              <NavLink to="/contact-us"> Contact Us </NavLink>
            </li>
          </ul>
        </div>

        {/* Right Section */}
        <div>
          <h3 className="text-xl font-bold text-[#D1A752] ">Address</h3>
          <ul className="mt-3 space-y-3">
            <li className="flex items-center mt-2 text-[#f5f5f5] text-lg  poppins-regular space-x-2">
              <FaMapMarkerAlt />{" "}
              <span>
                Babariya, Una-Talala Road, Sasan Gir, Gujarat 362135, India
              </span>
            </li>
            <li className="flex items-center mt-2 text-[#f5f5f5] text-lg  poppins-regular space-x-2">
              <FaPhone /> 
              <a href="tel:+919586900007" className="hover:underline ml-4">
                +91- 95869 00007
              </a>
            </li>
            <li className="flex mt-2 items-center  text-[#f5f5f5] text-lg  poppins-regular space-x-2">
              <FaGlobe />{" "}
              <a href="https://www.girglades.com" target="_blank" rel="noopener noreferrer" className="hover:underline ml-4">
                www.girglades.com
              </a>
            </li>
            <li className="flex mt-2 items-center  text-[#f5f5f5] text-lg  poppins-regular space-x-2">
              <FaRegEnvelope />{" "}
              <a href="mailto:info@girglades.com" className="hover:underline ml-4">
                hello@girglades.com
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Copyright Section */}
      <div className="text-center mt-12 text-sm poppins-regular">
        Copyright © 2025. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
